import { createTypes, createAction } from "lib/action";

const LOAD_PRODUCT = createTypes("products", "load");
const SHOW_PRODUCT = createTypes("products", "show");
const CREATE_PRODUCT = createTypes("products", "create");
const UPDATE_PRODUCT = createTypes("products", "update");
const DELETE_PRODUCT = createTypes("products", "delete");
const EXPORT_PRODUCT = createTypes("products", "export");
const IMPORT_PRODUCT = createTypes("products", "import");

const loadProducts = {
  request: (params, token) => createAction(LOAD_PRODUCT.REQUEST, { params, token }),
  success: (data) => createAction(LOAD_PRODUCT.SUCCESS, { data }),
  failure: (err) => createAction(LOAD_PRODUCT.FAILURE, { err }),
};

const showProduct = {
  request: (id, token) => createAction(SHOW_PRODUCT.REQUEST, { id, token }),
  success: (data) => createAction(SHOW_PRODUCT.SUCCESS, { data }),
  failure: (err) => createAction(SHOW_PRODUCT.FAILURE, { err }),
};

const createProduct = {
  request: (params, token) => createAction(CREATE_PRODUCT.REQUEST, { params, token }),
  success: (data) => createAction(CREATE_PRODUCT.SUCCESS, { data }),
  failure: (err) => createAction(CREATE_PRODUCT.FAILURE, { err }),
};

const updateProduct = {
  request: (params, id, token) => createAction(UPDATE_PRODUCT.REQUEST, { params, id, token }),
  success: (data) => createAction(UPDATE_PRODUCT.SUCCESS, { data }),
  failure: (err) => createAction(UPDATE_PRODUCT.FAILURE, { err }),
};

const exportProduct = {
  request: (params, token) => createAction(EXPORT_PRODUCT.REQUEST, { params, token }),
  success: (data) => createAction(EXPORT_PRODUCT.SUCCESS, { data }),
  failure: (err) => createAction(EXPORT_PRODUCT.FAILURE, { err }),
};

const importProduct = {
  request: (file, company_id, mode, token) => createAction(IMPORT_PRODUCT.REQUEST, { file, company_id, mode, token }),
  success: data => createAction(IMPORT_PRODUCT.SUCCESS, { data }),
  failure: err => createAction(IMPORT_PRODUCT.FAILURE, { err }),
}

const deleteProduct = {
  request: (id, token) => createAction(DELETE_PRODUCT.REQUEST, { id, token }),
  success: (id) => createAction(DELETE_PRODUCT.SUCCESS, { id }),
  failure: (err) => createAction(DELETE_PRODUCT.FAILURE, { err }),
};


export {
  loadProducts,
  showProduct,
  createProduct,
  updateProduct,
  exportProduct,
  importProduct,
  deleteProduct,
  LOAD_PRODUCT,
  SHOW_PRODUCT,
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  EXPORT_PRODUCT,
  IMPORT_PRODUCT,
  DELETE_PRODUCT
};


